import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, Button, message } from 'antd';
import { UsergroupAddOutlined,  } from '@ant-design/icons';
import axios from '../../config/axiosInstance';

const { Option } = Select;

const AddEditUser = ({ visible, onClose, user, onSave }) => {
  const [form] = Form.useForm();
  const [groups, setGroups] = useState([]);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    // Get Groups from backend
    const fetchGroups = async () => {
        try {
          const response = await axios.get('/groups');
          setGroups(response.data);
        } catch (error) {
          console.error('Error fetching groups:', error);
          message.error('Error fetching groups');
        }
    };

    // Get Clients from backend
    const fetchClients = async () => {
      try {
        const response = await axios.get('/clients');
        setClients(response.data);
      } catch (error) {
        console.error('Error fetching groups:', error);
        message.error('Error fetching groups');
      }
  };

    if (user) {
      form.setFieldsValue({
        username: user.username,
        firstname: user.firstname,
        lastname: user.lastname,
        groupID: user.groupID?._id || null,
        clientID: user.clientID?._id || null,
      });
    } else {
      form.resetFields();
    }

    fetchGroups();
    fetchClients();
  }, [user, form]);

  const handleFinish = async (values) => {
    try {
      if (user) {
        // Update user
        await axios.put(`/users/${user._id}`, values);
        message.success('User updated successfully');
      } else {
        // New user
        await axios.post('/users', values);
        message.success('User added successfully');
      }
      onSave(); 
      onClose(); 
    } catch (error) {
      console.error('Error saving user:', error);
      message.error('Error saving user. Please try again.');
    }
  };

  return (
    <Modal
      open={visible}
      title={user ? 'Edit User' : 'Add New User'}
      onCancel={onClose}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{ groupID: null, clientID: null }}
      >
        <Form.Item
          name="username"
          label="Username"
          rules={[
            { required: true, message: 'Please input the username!' },
            { min: 3, message: 'Username must be at least 3 characters' },
            { pattern: /^\S*$/, message: 'No spaces allowed in username' }, 
          ]}
        >
          <Input 
            placeholder="Enter username" 
            onChange={(e) => {
              e.target.value = e.target.value.replace(/\s/g, ''); // Remove spaces in real time
            }}
          />
        </Form.Item>
        <Form.Item
          name="password"
          label="Password"
          rules={[
            { required: !user, message: 'Please input your password!' }
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="firstname"
          label="First Name"
          rules={[{ required: true, message: 'Please input the first name!' }]}
        >
          <Input placeholder="Enter first name" />
        </Form.Item>
        <Form.Item
          name="lastname"
          label="Last Name"
          rules={[{ required: true, message: 'Please input the last name!' }]}
        >
          <Input placeholder="Enter last name" />
        </Form.Item>
        <Form.Item
          name="groupID"
          label={
            <span>
              <UsergroupAddOutlined style={{ fontSize: '18px', color: '#1890ff', marginRight: '5px' }} />
              Group
            </span>
          }
          rules={[{ required: true, message: 'Please select a group!' }]}
        >
          <Select>
            {groups.map((group) => (
              <Option key={group._id} value={group._id}>
                {group.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="clientID"
          label={
            <span>
              <UsergroupAddOutlined style={{ fontSize: '18px', color: '#1890ff', marginRight: '5px' }} />
              Clients
            </span>
          }
          rules={[{ required: true, message: 'Please select a client!' }]}
        >
          <Select>
            {clients.map((client) => (
              <Option key={client._id} value={client._id}>
                {client.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" htmlType="submit">
            {user ? 'Save Changes' : 'Add User'}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddEditUser;
